import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { API, graphqlOperation } from "aws-amplify";
import {
  getCodeTranslation,
  getCompany,
  listPlaceOfSupply,
  listUserCompanies,
} from "../../graphql";
import { PURGE } from "redux-persist";
import { showErrorSnackbar } from "../../components/snackBar/snakbar";
export const fetchStateList = createAsyncThunk("stateList", async () => {
  const states = await API.graphql(
    graphqlOperation(getCodeTranslation, { codetype: "IndiaState" })
  );
  if (states?.data) return states?.data;
});

const INITIAL_STATE = {
  stateList: [],
  render: true,
  Loaded: false,
  loading: false,
};
const StateList = createSlice({
  name: "state",
  initialState: INITIAL_STATE,
  reducers: {
    setPOSList(state, action) {
      state.stateList = action.payload;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchStateList.pending, (state) => {
        state.Loaded = false;
      })
      .addCase(fetchStateList.fulfilled, (state, action) => {
        if (action?.payload) {
          return {
            ...state,
            stateList: action.payload,
            Loaded: true,
          };
        } else {
          state.Loaded = true;
        }
      })
      .addCase(fetchStateList.rejected, (state) => {
        state.Loaded = false;
        showErrorSnackbar("Network Error !");
      })
      .addCase(PURGE, () => INITIAL_STATE);
  },
});

export const { setStateList } = StateList.actions;
export default StateList.reducer;
